import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useAuthStore } from '@/stores'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { isAuth: true },
    },
    {
      path: '/invoice',
      meta: { isAuth: true },
      component: () => import('@/views/invoice/InvoiceIndex.vue'),
      children: [
        {
          path: '',
          name: 'invoice',
          component: () => import('@/views/invoice/InvoiceData.vue'),
          meta: { title: 'Invoice' },
        },
        {
          path: ':code',
          name: 'invoice-detail',
          component: () => import('@/views/invoice/InvoiceDetail.vue'),
          meta: { title: 'Invoice', subTitle: 'Detail invoice' },
        },
      ],
    },
    {
      path: '/profile',
      meta: { isAuth: true },
      component: () => import('@/views/profile/ProfileIndex.vue'),
      children: [
        {
          path: '',
          name: 'profile',
          component: () => import('@/views/profile/ProfileData.vue'),
          meta: { title: 'Profile' },
        },
      ],
    },

    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginPage.vue'),
      meta: { isAuth: false },
    },
  ],

  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition
    } else {
      window.scrollTo(0, 0)
    }
  },
})

router.beforeEach((to, from, next) => {
  const auth = useAuthStore()
  const isAuth = auth.isAuth

  // Jika belum login, hanya boleh akses login
  if (!isAuth && to.meta.isAuth) {
    next({ name: 'login' })
    return
  }

  // Jika sudah login, tidak boleh akses page auth (login)
  if (isAuth && to.name === 'login') {
    next({ name: 'home' })
    return
  }

  next()
})

export default router
